"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _DynamicDropdown = _interopRequireDefault(require("./DynamicDropdown"));
var _excluded = ["value", "getItemsForQuery", "minTypeSize", "automationHook", "debounce"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Function for getting items. It expects the `debouncedSearchTerm` and a
   * `callback`  that gets called with the fetched results. The callback expects
   * to receive `(err, res)` where the result is the array of items */
  getItemsForQuery: _propTypes["default"].func.isRequired,
  /** Value for the field */
  value: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }),
  /** Function called when the selection changes. Will receive the selected item
   * as argument. Should set the value. */
  onChange: _propTypes["default"].func.isRequired,
  /** Minimum type size required for search to begin */
  minTypeSize: _propTypes["default"].number,
  /** Hook used along with "dropdown-search" for automation testing */
  automationHook: _propTypes["default"].string,
  /** Specifies the number of milliseconds for debounced searchTerm */
  debounce: _propTypes["default"].number
};
var DynamicDropdownSearch = function DynamicDropdownSearch(_ref) {
  var _debouncedSearchTerm$2;
  var value = _ref.value,
    getItemsForQuery = _ref.getItemsForQuery,
    _ref$minTypeSize = _ref.minTypeSize,
    minTypeSize = _ref$minTypeSize === void 0 ? 2 : _ref$minTypeSize,
    automationHook = _ref.automationHook,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 300 : _ref$debounce,
    rest = _objectWithoutProperties(_ref, _excluded);
  // state for list
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)((value === null || value === void 0 ? void 0 : value.label) || ""),
    _useState6 = _slicedToArray(_useState5, 2),
    searchTerm = _useState6[0],
    setSearchTerm = _useState6[1];
  var _useState7 = (0, _react.useState)(searchTerm),
    _useState8 = _slicedToArray(_useState7, 2),
    debouncedSearchTerm = _useState8[0],
    setDebouncedSearchTerm = _useState8[1];
  var canDoUpdate = (0, _react.useRef)(true);

  // debounced search term will only update when the user stops typing
  (0, _reactUse.useDebounce)(function () {
    return setDebouncedSearchTerm(searchTerm);
  }, debounce, [searchTerm]);
  (0, _react.useEffect)(function () {
    var _debouncedSearchTerm$;
    canDoUpdate.current = true;
    if ((debouncedSearchTerm === null || debouncedSearchTerm === void 0 ? void 0 : (_debouncedSearchTerm$ = debouncedSearchTerm.trim()) === null || _debouncedSearchTerm$ === void 0 ? void 0 : _debouncedSearchTerm$.length) < minTypeSize) {
      setItems([]);
      return;
    }
    setLoading(true);
    getItemsForQuery(debouncedSearchTerm, function (err, res) {
      var _searchTerm$trim;
      setLoading(false);

      // Before setting the items of the dropdown, it is important to verify
      // that there is still a search term (NOT the debounced one)
      if (canDoUpdate.current && searchTerm !== null && searchTerm !== void 0 && (_searchTerm$trim = searchTerm.trim()) !== null && _searchTerm$trim !== void 0 && _searchTerm$trim.length && !err) {
        setItems(res);
      }
    });
    return function () {
      canDoUpdate.current = false;
    };
    // we don't wanna add searchTerm in the dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, getItemsForQuery, minTypeSize]);

  // if value prop changes, set items to that option
  (0, _react.useEffect)(function () {
    setItems(value !== null && value !== void 0 && value.value ? [value] : []);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_DynamicDropdown["default"], _extends({
    items: items,
    loading: loading,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    value: value,
    userMustType: (debouncedSearchTerm === null || debouncedSearchTerm === void 0 ? void 0 : (_debouncedSearchTerm$2 = debouncedSearchTerm.trim()) === null || _debouncedSearchTerm$2 === void 0 ? void 0 : _debouncedSearchTerm$2.length) < minTypeSize,
    automationHook: automationHook
  }, rest));
};
DynamicDropdownSearch.propTypes = propTypes;
var _default = DynamicDropdownSearch;
exports["default"] = _default;